import { createLogger, createStore } from "vuex";
import auth from "./modules/auth";

export default createStore({
  plugins: process.env.NODE_ENV === "development" ? [createLogger()] : [],
  modules: {
    auth,
  },
});
